import { render, staticRenderFns } from "./EmployeeWorkTypesModal.vue?vue&type=template&id=ba2a418c&scoped=true&"
import script from "./EmployeeWorkTypesModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorkTypesModal.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWorkTypesModal.vue?vue&type=style&index=0&id=ba2a418c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2a418c",
  null
  
)

export default component.exports